import {GetterTree} from 'vuex';
import UserResource from '@/brief-hub/user/UserResource';
import type {ConnectedUserState} from './types';
import {StoreState} from '@/brief-hub/store/state/StoreState';

export const getters: GetterTree<ConnectedUserState, StoreState> = {
    connectedUser(state): UserResource | null {
        return state.user || null;
    },
    searchIdentities(state): string[] | undefined {
        return state.searchedIdentities;
    },
};
